import { baseApi } from './baseApi';

export const recommendationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLatestRecommendations: builder.query({
      query: () => '/market-data/recommendations',
      providesTags: ['Recommendations'],
    }),
    getRecommendationById: builder.query({
      query: (id) => `/market-data/recommendations/${id}`,
      providesTags: (result, error, id) => [{ type: 'Recommendation', id }],
    }),
    getRecommendationsByMarketAssetId: builder.query({
      query: (marketAssetId) => `/market-data/${marketAssetId}/recommendations`,
      providesTags: (result, error, marketAssetId) => [
        { type: 'MarketAssetRecommendations', id: marketAssetId }
      ],
    }),
    createRecommendation: builder.mutation({
      query: (marketAssetId) => ({
        url: `/market-data/${marketAssetId}/recommendations`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, marketAssetId) => [
        'Recommendations',
        { type: 'MarketAssetRecommendations', id: marketAssetId },
      ],
    }),
    deleteRecommendation: builder.mutation({
      query: (id) => ({
        url: `/market-data/recommendations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        'Recommendations',
        { type: 'Recommendation', id },
      ],
    }),
  }),
  overrideExisting: false,
});


